import * as React from "react";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { CircleBtn, CircleBtnType } from "../../../../../../../react-core/Html/CircleBtn";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { TransferType } from "../../../../../../../Wrap/Constants/Enums/Domain/TransferType";
import { ExternalIsaContributionType } from "../../../../../../../Wrap/Constants/Enums/Transfer/ExternalIsaContributionType";
import { ClientDetails } from "../../../../../../../Wrap/Models/Models/Processes/Quote/ClientDetails";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader } from "../../../AddClient/Components/SharedComponents";
import { SingleTransferInIsa } from "./SingleTransferInISA";
import { processTypeEnum } from "../../Resource/Contents";
import { SingleTransferInPP } from "./SingleTransferInPP";
import { SingleTransferInSIPP } from "./SingleTransferInSIPP";
import { SubAccountTypeHelper } from "../../Helpers/SubAccountTypeHelper";
import { InvestmentSelectionAction } from "../../../../../../Shared/IST/Action/InvestmentSelectionAction";
import { WizardLinter, EWizardLinterStatus } from "../../../../../../Shared/Process/Process/WizardLinter";
import { EWizardLinterHelper } from "../../../NewBusinessWizard/Resource/EWizardLinterHelper";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { PensionType } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import { SubAccountActionIndicators } from "../../../../../../../Wrap/Models/Models/Shared/SubAccountActionIndicators";
import { ServiceProposition } from "../../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { UserStore } from "../../../../../Stroes/Variable";
import { Action } from "../../../../../Actions/Action";
import { GENERIC_RESTRICTIONS_MESSAGE } from "../../../../../../Shared/Common/UserMessages";

interface ITransferInProps extends IProcessComponentProps {
    isPost: boolean;
    subAccountType: SubAccountType;
    clientDetails?: ClientDetails;
    jouneryType: processTypeEnum;
    hasCashIsa?: boolean;
    HasExistingSIPP?: boolean;
    disabled?: boolean;
    pensionType?: PensionType;
    selectedProducts?: Array<SubAccountActionIndicators>;
    accountServiceProposition: ServiceProposition;
    claccountId?: string; 
    subAccountInstructionHierarchy?: string;
}

interface ITransferInState {
    expandList: boolean[];
    displayExceedIsaAllowanceError: boolean;
    userInfo: User;
}

export class TransferIn extends ProcessComponent<ITransferInProps, ITransferInState> {
    constructor(props: any) {
        super(props);
        this.state = {
            userInfo: UserStore.getUserInfo(),
            expandList: [],
            displayExceedIsaAllowanceError: false,
        };
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        InvestmentSelectionAction.setIsUnderTransfer(false);
    }

    componentDidMount() {
        super.componentDidMount();

        InvestmentSelectionAction.setIsUnderTransfer(true);
        const { data } = this.props;
        const expandList = [];
        if (data) {
            const len = data.length;
            for (let i = 0; i < len; i++) {
                expandList.push(true);
            }
        }

        this.setState({ expandList });
    }

    private onTransfersChange(data: any) {
        switch (this.props.subAccountType) {
            case SubAccountType.Sipp:
            case SubAccountType.JuniorSipp:
            case SubAccountType.Npr:
                this.props.onChange({ PensionTransfers: data });
                break;
            case SubAccountType.InvestmentAccount:
                this.props.onChange({ GiaTransfers: data });
                break;
            case SubAccountType.StocksIsa:
                this.props.onChange({ IsaTransfers: data });
                break;
        }
    }

    private addTransferIn() {
        const { data } = this.props;
        const { expandList } = this.state;
        if (data && data.length !== 0 && !this.isValidChild(data.length - 1)) {return;}
        const _data = data ? data.concat() : [];
        if (
            this.props.subAccountType === SubAccountType.InvestmentAccount &&
            this.props.jouneryType !== processTypeEnum.NewBusiness
        ) {
            _data.push({
                TransferCash: null,
                TransferInSpecie: [],
                ProviderDetails: null,
                ExternalOwnershipDetails: null,
                TransferType: TransferType.InSpecie,
                Instruments: [],
            });
        } else if (
            this.props.subAccountType === SubAccountType.InvestmentAccount &&
            this.props.jouneryType === processTypeEnum.NewBusiness
        ) {
            _data.push({
                ProviderDetails: null,
                ExternalOwnershipDetails: null,
                TransferType: TransferType.InSpecie,
                Instruments: [],
            });
        } else if (this.props.subAccountType === SubAccountType.StocksIsa) {
            _data.push({
                CurrentValue: null,
                ReRegisterValue: null,
                TransferType: null,
                ContributionType: ExternalIsaContributionType.PreviousTaxYear,
                CashIsaToBeTransferredToSSIsa: true,
                Instruments: [],
                ExternalOwnershipDetails: null,
            });
        } else if (
            SubAccountTypeHelper.isOnPlatformPension(this.props.subAccountType, true) &&
            (this.props.jouneryType === processTypeEnum.Quote ||
                this.props.jouneryType === processTypeEnum.NewQuoteExistingClient ||
                this.props.jouneryType === processTypeEnum.WhatIfTool)
        ) {
            _data.push({
                PensionSource: null,
                CurrentValue: null,
                TransferType: null,
                DrawdownType: null,
                IncomePaymentDetails: null,
                PensionDetails: { IsDependentsPension: false },
                Instruments: [],
            });
        } else if (
            this.props.subAccountType === SubAccountType.JuniorSipp &&
            (this.props.jouneryType === processTypeEnum.Quote ||
                this.props.jouneryType === processTypeEnum.NewQuoteExistingClient ||
                this.props.jouneryType === processTypeEnum.WhatIfTool)
        ) {
            _data.push({
                PensionSource: null,
                CurrentValue: null,
                TransferType: null,
                DrawdownType: null,
                IncomePaymentDetails: null,
                PensionDetails: { IsDependentsPension: true },
                Instruments: [],
            });
        } else if (
            SubAccountTypeHelper.isOnPlatformPension(this.props.subAccountType, true) &&
            (this.props.jouneryType === processTypeEnum.NewBusiness ||
                this.props.jouneryType === processTypeEnum.SinglePaymentTransfer ||
                this.props.jouneryType === processTypeEnum.topUpWithITFLS ||
                this.props.jouneryType === processTypeEnum.NewBusinessExistingClient)
        ) {
            _data.push({
                PensionSource: null,
                CurrentValue: null,
                TransferType: null,
                DrawdownType: null,
                IncomePaymentDetails: null,
                PensionDetails: { IsDependentsPension: false },
                Instruments: [],
            });
        } else if (
            this.props.subAccountType === SubAccountType.JuniorSipp &&
            (this.props.jouneryType === processTypeEnum.NewBusiness ||
                this.props.jouneryType === processTypeEnum.SinglePaymentTransfer ||
                this.props.jouneryType === processTypeEnum.topUpWithITFLS ||
                this.props.jouneryType === processTypeEnum.NewBusinessExistingClient)
        ) {
            _data.push({
                PensionSource: null,
                CurrentValue: null,
                TransferType: null,
                DrawdownType: null,
                IncomePaymentDetails: null,
                PensionDetails: { IsDependentsPension: true },
                Instruments: [],
            });
        }
        this.onTransfersChange(_data);
        expandList[expandList.length - 1] = false;
        expandList.push(true);
        this.setState({ expandList });
    }

    private onRemoveTransfer(i) {
        const { data } = this.props;
        const { expandList } = this.state;
        const _data = data.concat();
        _data.splice(i, 1);
        expandList.splice(i, 1);
        this.onTransfersChange(_data);
        this.setState({ expandList });
    }

    private onTransferChange(changes, i) {
        const { data } = this.props;
        const _data = data.concat();
        const _item = _data[i];
        for (const key in changes) {
            _item[key] = changes[key];
        }
        _data[i] = _item;
        this.onTransfersChange(_data);
    }

    public render(): JSX.Element {
        const { data, subAccountType } = this.props;

        let restrictedMessage = "An account with suspended or restricted activities cannot setup transfer in";

        if (this.state.userInfo != null && this.state.userInfo.IsAdviser) {
            restrictedMessage = GENERIC_RESTRICTIONS_MESSAGE;
        }

        return (
            <WizardLinter
                status={EWizardLinterStatus.PleaseCheck}
                enabled={EWizardLinterHelper.shouldDisplay(subAccountType)}
            >
                {SectionHeader("Transfer in")}
                {this.props.disabled == true && <Alert alertType={AlertType.Error} message={restrictedMessage} />}
                <RadiosEditor
                    cssWrapper="radio-group rg-150 mb-16"
                    selected={!isNullOrEmpty(data)}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) => {
                        if (v) {
                            this.addTransferIn();
                        } else {
                            this.setState({ expandList: [] });
                            this.onTransfersChange([]);
                        }
                    }}
                    disabled={this.props.disabled == true ? true : false}
                    required={"Please select "}
                />
                {data &&
                    data.map((ele, index) => {
                        return (
                            <Accordion
                                key={`Transfer In - ${index + 1}`}
                                label={`Transfer ${index + 1}`}
                                cssWrapper="accordion-simple"
                                // onRemove={() => this.onRemoveTransfer(index)}
                                onChange={(v) => (v ? true : this.isValidChild(index))}
                                isOpen={this.state.expandList[index]}
                            >
                                {(SubAccountTypeHelper.isOnPlatformPension(this.props.subAccountType) ||
                                this.props.subAccountType === SubAccountType.JuniorSipp) && (
                                    <SingleTransferInSIPP
                                        isPost={this.props.isPost}
                                        onRef={(ref) => this.appendChild(ref, index)}
                                        data={ele}
                                        onChange={(changes) => this.onTransferChange(changes, index)}
                                        showErrorMsgPopUp={(msg, showNow) => this.props.showErrorMsgPopUp(msg, showNow)}
                                        index={index + 1}
                                        subAccountType={this.props.subAccountType}
                                        jouneryType={this.props.jouneryType}
                                        isReview={this.props.isReview}
                                        accountServiceProposition={this.props.accountServiceProposition}
                                        HasExistingSIPP={this.props.HasExistingSIPP}
                                        selectedProducts={this.props.selectedProducts}
                                        subAccountInstructionHierarchy={this.props.subAccountInstructionHierarchy}
                                    />
                                )}
                                {this.props.subAccountType === SubAccountType.InvestmentAccount && (
                                    <SingleTransferInPP
                                        isPost={this.props.isPost}
                                        onRef={(ref) => this.appendChild(ref, index)}
                                        data={ele}
                                        clientDetails={this.props.clientDetails}
                                        onChange={(changes) => this.onTransferChange(changes, index)}
                                        showErrorMsgPopUp={(msg, showNow) => this.props.showErrorMsgPopUp(msg, showNow)}
                                        index={index + 1}
                                        jouneryType={this.props.jouneryType}
                                        isReview={this.props.isReview}
                                        accountServiceProposition={this.props.accountServiceProposition}
                                        claccountId={this.props.claccountId}
                                    />
                                )}
                                {this.props.subAccountType === SubAccountType.StocksIsa && (
                                    <SingleTransferInIsa
                                        isPost={this.props.isPost}
                                        onRef={(ref) => this.appendChild(ref, index)}
                                        data={ele}
                                        onChange={(changes) => this.onTransferChange(changes, index)}
                                        showErrorMsgPopUp={(msg, showNow) => this.props.showErrorMsgPopUp(msg, showNow)}
                                        index={index + 1}
                                        isQuote={this.props.jouneryType === processTypeEnum.Quote}
                                        hasCashIsa={this.props.hasCashIsa}
                                        isReview={this.props.isReview}
                                        accountServiceProposition={this.props.accountServiceProposition}
                                        claccountId={this.props.claccountId}
                                    />
                                )}

                                <div>
                                    <CircleBtn
                                        type={CircleBtnType.remove}
                                        cssWrapper="mr-52"
                                        title="Remove this transfer"
                                        onClick={() => this.onRemoveTransfer(index)}
                                    />
                                    {data?.length != 0 && (
                                        <CircleBtn
                                            type={CircleBtnType.add}
                                            title="Add another transfer"
                                            onClick={() => this.addTransferIn()}
                                        />
                                    )}
                                </div>
                            </Accordion>
                        );
                    })}
            </WizardLinter>
        );
    }
}
